<template>
  <div class="tools pa-4">
    <!-- <v-textarea :value="infoStr"></v-textarea> -->
    <v-btn @click="showLoginStatus" depressed>
      SHOW LOGIN STATUS
    </v-btn>
    <v-btn @click="testLogin" depressed>
      TEST LOGIN
    </v-btn>
    <v-btn @click="logout" depressed>
      LOGOUT
    </v-btn>
    <br>
    <v-btn @click="getAuthToken">
      GET Auth Token
    </v-btn>
    <v-btn
      color="grey lighten-5"
      v-google-signin-button="googleClientId"
      class="google-signin-button black--text"
      depressed
    >
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 48 48" class="abcRioButtonSvg"><g><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path><path fill="none" d="M0 0h48v48H0z"></path></g></svg>
      <span class="d-inline-block" style="width: 0.5rem;"></span>
      Login with Google
    </v-btn>
    <v-btn @click="checkURL">
      CHECK URL
    </v-btn>
    <div style="margin:2rem;">
      <v-divider></v-divider>
    </div>
    <div
      v-if="infoStr"
      class="pa-4"
      :class="{'pink darken-4': !!error}"
      style="border:1px solid rgba(255, 255, 255, 0.5); max-height:400px; overflow: scroll;"
    >
      <pre v-html="infoStr"></pre>
    </div>
  </div>
</template>

<script>
import jwt from 'jsonwebtoken'
import { loginByToken } from '@/lib/auth/google-login'
import GoogleSignInButton from 'vue-google-signin-button-directive'
/* eslint-disable no-unused-vars */
import axios from '@/lib/axios'
import qs from 'qs'

let testToken = `eyJhbGciOiJSUzI1NiIsImtpZCI6Ijc0YmQ4NmZjNjFlNGM2Y2I0NTAxMjZmZjRlMzhiMDY5YjhmOGYzNWMiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJhY2NvdW50cy5nb29nbGUuY29tIiwiYXpwIjoiMzQ5NTY0MjUwODg4LTJpMHBuNGtubmE2ODVqdG1tOXQ1b2dycmFpM2sxZnBlLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29tIiwiYXVkIjoiMzQ5NTY0MjUwODg4LTJpMHBuNGtubmE2ODVqdG1tOXQ1b2dycmFpM2sxZnBlLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29tIiwic3ViIjoiMTAwOTI1MDg5MjA4MTAyOTA3NDY5IiwiZW1haWwiOiJsaWFva2VtbUBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiYXRfaGFzaCI6InB3emtUM0V5ZWFVNUE0cEFIWDBubHciLCJuYW1lIjoiYW5keSBsaWFvIiwicGljdHVyZSI6Imh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hLS9BT2gxNEdnX1lnLTctRC1tZFJEeF8yekFYZE5WeWl5QndScnhaYWlMS1RGQThBPXM5Ni1jIiwiZ2l2ZW5fbmFtZSI6ImFuZHkiLCJmYW1pbHlfbmFtZSI6ImxpYW8iLCJsb2NhbGUiOiJ6aC1UVyIsImlhdCI6MTU4ODc4MzEzNCwiZXhwIjoxNTg4Nzg2NzM0LCJqdGkiOiI5MzU5MGY1MmZiYjE3ZGUzYTZlNGEzMzBiNWExNDY5Nzg2MTE3NTczIn0.DiqrTdRsjZ9dVf9vRKmk88YPLU1r1WauwQf5vVml2QerKQqq-yyw6P4xuWhY7OvTHFCqkuyLZZFqV8oJpqgrKhPOBCQO0_lh0KtxQWTEuCJahORrFl_ClpARGZKinLQctvFGV-8fkIJGaolX1vIRFhVy8u5tJLGFIa2_r_SgR6yfUcuitDe8xSwzefBLukp2damXOmFamZ3HrpC_5zsaTHqvOQ_Xdg3tHXcsIL6n_8cv8sfmTQTvoxgzXfgeLjFyyQ-t56Jh67Ukeq_tGmK62B_HapZ2_kw6vqsyZ6xvIr4gmIzrjCh_EUVHoynU9AImxScx5IJCEYKQuoOXNpsg-Q`

export default {
  directives: {
    GoogleSignInButton
  },
  data(){
    return {
      error: false,
      infoStr: '',
      googleClientId:
        '349564250888-2i0pn4knna685jtmm9t5ogrrai3k1fpe.apps.googleusercontent.com'
    }
  },
  mounted(){
    if(!this.$dev){
      this.$router.replace('/')
    }
  },
  methods: {
    log(...args){
      this.error = false
      console.log(console, Array.from(args))
      if(args.length === 1){
        this.infoStr = JSON.stringify(args[0], null, 2)
      }else{
        this.infoStr = JSON.stringify(args, null, 2)
      }
    },
    logErr(...args){
      this.error = true
      console.error(console, Array.from(args))
      if(args.length === 1){
        this.infoStr = JSON.stringify(args[0], null, 2)
      }else{
        this.infoStr = JSON.stringify(args, null, 2)
      }
    },
    async showLoginStatus(){
      let res = await axios.get('/wordprison/user')
      this.log(res.data)
    },
    async testLogin(){
      let token = testToken
      loginByToken(token)
        .then((res)=>{
          if(res.data.user){
            this.$store.commit('user/setup', res.data.user)
            this.infoStr = JSON.stringify(res.data, null, 2)
            // this.$router.replace('/')
          }
        })
        .catch((e)=>{
          this.logErr(e)
        })
    },
    async logout(){
      axios.get('/wordprison/logout')
        .then(res=>{
          this.log(res.data)
          this.$store.commit('user/clear')
        })
    },
    async getAuthToken(){
      axios.post('/wordprison/auth/assistant')
        .then((res)=>{
          this.log(res.data)
        })
        .catch((e)=>{
          this.logErr(e.response.data)
        })
    },
    async checkURL(){
      let url = new URL(`https://game.voiss.nctu.me/home/login?to=%24assistant&response_type=token&client_id=andy-self-test-clientid&redirect_uri=https%3A%2F%2Foauth-redirect.googleusercontent.com%2Fr%2Fandy-self-test&scope=profile&state=ABdO3MVf6pG44H_hQtU-ipdo-iAP36YCvADdtgcqi9--80GWcZBDDsJcREPj73wAfCSEmlmbkpEo-rCiGMsspLgSf4817HMNuvBWrnlNczYtug7Ki9hxqFAM90HyEuLFtzSb6VfIQ1T5Ak_Fpu0utU9XhOIz-2YaPTRkLuvMXnPgxv3bI3UPV4mjXjwCW781e8POM6XDdGcOk2HbIiio2j7WgeTQqLa6dpKNB2ghkpE7I_ZwVnmlHrpchBQqIyoA_WqpUwzFsEavn4-P-kj5MXPRtTtCknIpvyQIxaOKe_XjSTNVFmYiXkqHbgJN3VojEnZAydCpwJb6I2iaGiH8DNPG7-6bRjpkBphCibJk-8aRsKc0kNoJHIGKVdrFCl5HhFLHZPJ_uQ0CPE19uztVyGB4FOf_AUu5ZDfU3cfVsHmhUjM83j0CH-GI50VNe2c0cy23eIRCFfVdzf230_js2gsWRGjwC7aZzKXUeMQoHOWAPR9vgtohx7RJueUHcbUFbmPZnwuJdljW3gMDvtX5snFmgmBmlFgVjd-kQ_lmrYq9YuZGC4J7I64&user_locale=zh-TW`)
      let map = {}
      url.searchParams.forEach((v, k)=>{
        map[k] = v
      })
      map._state = jwt.decode(map.state)
      console.log(map)
      this.log(qs.stringify({ a: 5, b: 10 }))
    },
    OnGoogleAuthSuccess(idToken) {
      console.log('idToken', idToken)
      loginByToken(idToken)
        .then((res)=>{
          if(res.data.user){
            this.$store.commit('user/setup', res.data.user)
            this.log(res.data)
          }
        })
        .catch((e)=>{
          this.logErr(e)
        })
    },
    OnGoogleAuthFail(error) {
      console.log(error)
    },
    async loginAssistant(){
      let {
        client_id: cliendId,
        redirect_uri: redirectUri,
        response_type: responseType,
        state
      } = this.$route.query
      if(cliendId && redirectUri && responseType && state){
        let res = await axios.post('/wordprison/auth/assistant')
        let token = res.data.payload.token.token
        console.log(`https://oauth-redirect.googleusercontent.com/r/`)
      }
    }
  }
}
</script>

<style scoped>
  .tools .v-btn{
    margin: 0.5rem;
  }
</style>
